import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import {
  Grid,
  FormControl,
  Divider,
  Typography,
  TextField,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Autocomplete,
  Box,
  CircularProgress,
} from "@mui/material";
import ServiceType from "./ServiceType";
import {
  FormData,
  IDistrict,
  IProvince,
  ITambon,
} from "./MainFormPersonaNewV1";
import { APIEndpointWeb, webapi } from "../../../../client/web";

const provinceOptions = [
  { label: "กาฬสินธุ์", value: "กาฬสินธุ์" },
  { label: "ขอนแก่น", value: "ขอนแก่น" },
];

const districtOptions = [
  { label: "ยางตลาด", value: "ยางตลาด" },
  { label: "เมือง", value: "เมือง" },
];

const sub_districtOptions = [
  { label: "หัวนาคำ", value: "หัวนาคำ" },
  { label: "ยางตลาด", value: "ยางตลาด" },
];

const serviceOptions = [
  { name: "คลินิก", label: "คลินิก" },
  { name: "ร้านยา", label: "ร้านยา" },
  { name: "โรงพยาบาลเอกชน", label: "โรงพยาบาลเอกชน" },
  { name: "อื่นๆ", label: "อื่นๆ" },
];

const clinicOptions = [
  { name: "คลินิกเวชกรรม", label: "คลินิกเวชกรรม", value: "คลินิกเวชกรรม" },
  {
    name: "คลินิกกายภาพบำบัด",
    label: "คลินิกกายภาพบำบัด",
    value: "คลินิกกายภาพบำบัด",
  },
  { name: "คลินิกทันตกรรม", label: "คลินิกทันตกรรม", value: "คลินิกทันตกรรม" },
  {
    name: "คลินิกการแพทย์แผนไทย",
    label: "คลินิกการแพทย์แผนไทย",
    value: "คลินิกการแพทย์แผนไทย",
  },
  {
    name: "คลินิกเฉพาะด้าน",
    label: "คลินิกเฉพาะด้าน",
    value: "คลินิกเฉพาะด้าน",
  },
  {
    name: "คลินิกการประกอบโรคศิลปะ",
    label: "คลินิกการประกอบโรคศิลปะ",
    value: "คลินิกการประกอบโรคศิลปะ",
  },
  {
    name: "คลินิกเทคนิคการแพทย์",
    label: "คลินิกเทคนิคการแพทย์",
    value: "คลินิกเทคนิคการแพทย์",
  },
  { name: "multiClinic", label: "สหคลินิก ประกอบด้วย", value: "multiClinic" },
  {
    name: "คลินิกการพยาบาลและการผดุงครรภ์",
    label: "คลินิกการพยาบาลและการผดุงครรภ์",
    value: "คลินิกการพยาบาลและการผดุงครรภ์",
  },
  { name: "ร้านยา", label: "ร้านยา", value: "ร้านยา" },
  { name: "โรงพยาบาล", label: "โรงพยาบาล", value: "โรงพยาบาล" },
  { name: "อื่นๆ", label: "อื่นๆ", value: "other" },
];

// interface FormData {
//   orgenization_data: string; //ข้อมูลหน่วยบริการ
//   health_office_type: boolean;
//   hname_th: string;  //ชื่อหน่วยบริการ
//   hcode: string;  //รหัสหน่วยบริการ
//   address: string;
//   moo: string;
//   soi: string;
//   street: string;
//   province: string;
//   district: string;
//   sub_district: string;
//   zip_code: string;
//   email: string;
//   mobile_number: string;

// }
// interface FormDataServiceType {
//   service_type: string;
//   service_type_note: string;
//   otherDetails: string;
// }

interface FormDataServiceType {
  serviceType: string;
  clinicDetails: string;
  otherDetails: string;
}

// interface FormData  {
// organization_data: any;
//   health_office_type: string;
//   hname_th: string;
//   hcode: string;
//   address: string;
//   moo: string;
//   soi: string;
//   street: string;
//   province: string;
//   district: string;
//   sub_district: string;
//   zip_code: string;
//   email: string;
//   mobile_number: string;
// }

interface IDataMainFormPersonaNew {
  formData: FormData;
  setFormData: any;
  errors: any;
  setErrors: any;
  allProvince: IProvince[];
}

const ServiceInfoV1: React.FC<IDataMainFormPersonaNew> = ({
  formData,
  setFormData,
  allProvince,
  errors,
  setErrors,
}) => {
  const [formDataServiceType, setFormDataServiceType] =
    useState<FormDataServiceType>({
      serviceType: "",
      clinicDetails: "",
      otherDetails: "",
    });
  //   const [formData, setFormData] = useState<FormData>({
  //     health_office_type: "",
  //     hname_th: "",
  //     hcode: "",
  //     address: "",
  //     moo: "",
  //     soi: "",
  //     street: "",
  //     province: "",
  //     district: "",
  //     sub_district: "",
  //     zip_code: "",
  //     email: "",
  //     mobile_number: "",
  //   });

  //   const [errors, setErrors] = useState<{ [key: string]: boolean }>({});
  // const [testService, setTestService] = useState();
  const [loadingDistricts, setLoadingDistricts] = useState<boolean>(false);
  const [loadingTambon, setLoadingTambon] = useState<boolean>(false);
  const [allDistricts, setAllDistricts] = useState<IDistrict[]>([]);
  const [allTambon, setAllTambon] = useState<ITambon[]>([]);

  useEffect(() => {
    const storedDataServiceInfo = sessionStorage.getItem("serviceInfo");
    if (storedDataServiceInfo) {
      try {
        setFormData(JSON.parse(storedDataServiceInfo));
      } catch (error) {
        console.error("Error parsing JSON from localStorage:", error);
      }
    }

    const storedDataServiceType = sessionStorage.getItem("serviceType");
    if (storedDataServiceType) {
      try {
        setFormData(JSON.parse(storedDataServiceType));
      } catch (error) {
        console.error("Error parsing JSON from localStorage:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (
      Array.isArray(allProvince) &&
      allProvince.length > 0 &&
      formData &&
      formData?.organization_data?.province
    ) {
      // const filtered = allDistricts.filter((d) => d.province_code === selectedProvince.province_code);
      // setFilteredDistricts(filtered);
      // console.log("formData?.organization_data?.province", formData.organization_data.province)
      // if (dataProvince) {
      const xml = allProvince.find(
        (p: IProvince) =>
          p.province_thai_name === formData.organization_data.province
      );
      if (xml) {
        getDataAllDistrict(xml, formData);
      } else {
        setFormData((prev: any) => ({
          ...prev,
          organization_data: {
            ...prev.organization_data,
            province: "",
            district: "",
            sub_district: "",
            zip_code: "",
          },
        }));
        // }
      }
    }
  }, [allProvince]);

  const getDataAllDistrict = async (
    value: IProvince | null,
    dataProvince: any | null = null
  ) => {
    // console.log('value sdss:>> ', value?.province_code);
    try {
      setLoadingDistricts(true);
      setLoadingTambon(true);
      var { data } = await webapi.get(
        `${APIEndpointWeb.GetAllDistrict}${value?.province_code}`
      );
      // console.log("data.result", data.result)
      if (Array.isArray(data.result)) {
        setAllDistricts(data.result);
        if (value && dataProvince) {
          const xml = data.result.find(
            (p: any) =>
              p.district_thai_name === dataProvince.organization_data.district
          );
          // console.log("xmlxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx", ต้องลบ)
          if (xml) {
            let dataCode: IDistrict = {
              province_code: xml.province_code,
              district_english_name: xml.district_english_name,
              district_thai_name: xml.district_thai_name,
              district_code: xml.district_code,
            };
            await getDataGetAllTambon(dataCode, dataProvince);
          } else {
            setFormData((prev: any) => ({
              ...prev,
              organization_data: {
                ...prev.organization_data,
                district: "",
                sub_district: "",
                zip_code: "",
              },
            }));
          }
        }
      } else {
        setAllDistricts([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingDistricts(false);
      setLoadingTambon(false);
    }
  };

  const getDataGetAllTambon = async (
    selectedOption: IDistrict | null,
    dataProvince: any | null = null
  ) => {
    // console.log("selectedOption", selectedOption)
    try {
      setLoadingTambon(true);
      var { data } = await webapi.get(
        `${APIEndpointWeb.GetAllTambon}${selectedOption?.district_code}&province_code=${selectedOption?.province_code}`
      );
      // console.log('getDataGetAllTambon :>> ', data.result);
      // console.log('dataProvinceSubbbbbbbbbbbb :>> ', dataProvince?.sub_district);
      if (Array.isArray(data.result)) {
        setAllTambon(data.result);
        /////////////////////////////////////////////// ทำครั้งแรก
        // console.log("dataProvince", dataProvince)
        // console.log("selectedOption", selectedOption)
        if (dataProvince) {
          const xml = data.result.find(
            (p: any) =>
              p.tambon_thai_name === dataProvince.organization_data.sub_district
          );
          if (xml) {
            let formDatamock = formData;
            formDatamock.organization_data.zip_code = xml.zip_code;
            setFormData((prev: any) => ({
              ...prev,
              organization_data: {
                ...prev.organization_data,
                zip_code: xml.zip_code,
              },
            }));
          } else {
            setFormData((prev: any) => ({
              ...prev,
              organization_data: {
                ...prev.organization_data,
                sub_district: "",
                zip_code: "",
              },
            }));
          }
        }
      } else {
        setAllTambon([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingTambon(false);
    }
  };
  const validateMobile = (business_full_cid_1: string) => {
    return /^[0-9]{10}$/.test(business_full_cid_1);
  };

  const validateEmail = (email: string) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleFormChangeInfo = (
    e: React.ChangeEvent<HTMLInputElement> | any
  ) => {
    const { name, value } = e.target;
    setFormData((prev: { organization_data: FormData }) => {
      // console.log("prev :>> ", prev);
      return {
        ...prev,
        organization_data: {
          ...prev.organization_data,
          [name]: value,
        },
      };
    });
    setErrors((prevErrors: any) => {
      const newErrors = { ...prevErrors };

      // ✅ ตรวจสอบให้แน่ใจว่า organization_data มีอยู่
      if (!newErrors.organization_data) {
        newErrors.organization_data = {};
      }

      // ✅ แยก key ออกมาในกรณีเป็น "organization_data.email"
      const fieldName = name.startsWith("organization_data.")
        ? name.split(".")[1]
        : name;

      // ✅ ตรวจสอบ address
      if (fieldName === "address") {
        if (value.trim()) {
          delete newErrors.organization_data.address;
        } else {
          newErrors.organization_data.address =
            "กรุณากรอกสถานที่ตั้งหน่วยบริการ";
        }
      }
      // ✅ ตรวจสอบ email
      else if (fieldName === "email") {
        if (!validateEmail(value)) {
          newErrors.organization_data.email = "อีเมลไม่ถูกต้อง";
        } else {
          delete newErrors.organization_data.email;
        }
      } else if (fieldName === "mobile_number") {
        if (!validateMobile(value)) {
          newErrors.organization_data.mobile_number =
            "หมายเลขโทรศัพท์มือถือไม่ถูกต้อง";
        } else {
          delete newErrors.organization_data.mobile_number;
        }
      }
      // ✅ สำหรับฟิลด์อื่น ๆ ให้กำหนดเป็น true
      else {
        if (value.trim()) {
          delete newErrors.organization_data[fieldName]; // ถ้ากรอกข้อมูลแล้วให้ลบ error
        } else {
          newErrors.organization_data[fieldName] = "กรุณากรอกข้อมูล"; // ถ้าค่าว่างให้แสดง error
        }
      }

      return newErrors;
    });

    // setErrors((prevErrors: any) => {
    //     const newErrors = { ...prevErrors };

    //     // Check if the field is inside organization_data
    //     if (name === "address") {
    //         if (value.trim()) {
    //             delete newErrors["organization_data.address"];
    //         } else {
    //             newErrors["organization_data.address"] = true;
    //         }
    //     } else if (name === "mobile_number") {
    //         if (!validateMobile(value)) {
    //             newErrors[name] = true;
    //         } else {
    //             delete newErrors[name];
    //         }
    //     } else {
    //         if (value.trim()) {
    //             delete newErrors[name];
    //         } else {
    //             newErrors[name] = true;
    //         }
    //     }
    //     return newErrors;
    // });

    // console.log('name :>> ', name);
    // if (name === "mobile_number") {
    //     setErrors((prevErrors: { organization_data: FormData; [key: string]: any }) => {
    //         const newErrors: { organization_data: FormData; [key: string]: any } = { ...prevErrors };

    //         if (!validateMobile(value)) {
    //             newErrors[name] = true; // Set error only for the field being updated
    //         } else {
    //             delete newErrors[name]; // Remove error if valid
    //         }

    //         return newErrors;
    //     });
    // } else if (name === "email") {
    //     setErrors((prevErrors: { organization_data: FormData; [key: string]: any }) => {
    //         const newErrors: { organization_data: FormData; [key: string]: any } = { ...prevErrors };

    //         if (!validateEmail(value)) {
    //             newErrors[name] = true; // Set error only for the field being updated
    //         } else {
    //             delete newErrors[name]; // Remove error if valid
    //         }

    //         return newErrors;
    //     });

    // } else {
    //     setErrors((prevErrors: any) => {
    //         const newErrors = { ...prevErrors };
    //         // ตรวจสอบว่า value ของฟิลด์นี้มีค่าหรือไม่
    //         if (value.trim()) {
    //             delete newErrors[name]; // ถ้ามีค่าให้ลบข้อผิดพลาด
    //         } else {
    //             newErrors[name] = true;
    //         }
    //         return newErrors;
    //     });
    // }
  };

  const handleCheckboxServiceInfo = (value: string) => {
    // setFormData((prev: { health_office_type: string; }) => ({
    //     ...prev,
    //     health_office_type: prev.health_office_type === value ? "" : value,
    // }));
    setFormData((prev: any) => ({
      ...prev,
      organization_data: {
        ...prev.organization_data,
        health_office_type:
          prev.organization_data.health_office_type === value
            ? prev.organization_data.health_office_type
            : value,
      },
    }));
    setErrors((prev: any) => ({ ...prev, health_office_type: false }));
  };
  // useEffect(() => {
  //     if (formData.service_type === "สหคลินิก" || formData.service_type === "อื่นๆ") {
  //         setFormData((prev: any) => ({
  //             ...prev,
  //             service_type_note: prev.service_type_note, // คงค่าของ service_type_note เดิม
  //         }));
  //     } else {
  //         setFormData((prev: any) => ({
  //             ...prev,
  //             service_type_note: "", // เคลียร์ค่าเมื่อเลือกประเภทอื่น
  //         }));
  //     }
  // }, [formData.service_type]);

  const handleCheckboxServiceType = (value: string) => {
    // setFormData((prev: any) => {
    //     // ถ้า service_type มีค่าอยู่แล้ว ให้คืนค่าเดิม (ไม่เปลี่ยนแปลง)
    //     if (prev.service_type) {
    //         return prev;
    //     }

    //     return {
    //         ...prev,
    //         service_type: value, // กำหนดค่า service_type เป็นค่าที่เลือก
    //         service_type_note: (value === "สหคลินิก" || value === "อื่นๆ") ? prev.service_type_note : "",
    //     };
    // });

      var formDataServiceTypeNote = ""; // เคลียร์ค่าเมื่อเลือกประเภทอื่น

    setFormData((prev: any) => {
      const isChecked = prev.service_type === value;
      // console.log("isChecked :>> ", isChecked);
      // console.log("prev.service_type :>> ", prev.service_type);
      // console.log("value :>> ", value);
      return {
        ...prev,
        service_type: value,
        service_type_note: formDataServiceTypeNote,

        // service_type_note: (value === "สหคลินิก" || value === "อื่นๆ")
        // ? prev.service_type_note
        // : (isChecked ? prev.service_type_note : formData.service_type_note || ""),

        // service_type_note: prev.service_type !== "สหคลินิก" && prev.service_type !== "อื่นๆ" ? prev.service_type_note :
        //     isChecked ? value : prev.service_type_note,
      };
    });
  };

  const handleTextServiceType = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
    setErrors((prev: any) => ({ ...prev, [name]: value.trim() === "" }));
  };

  // const validateFormServiceType = () => {
  //     let newErrors: { [key: string]: boolean } = {};
  //     if (formDataServiceType.serviceType === "multiClinic" && !formDataServiceType.clinicDetails) {
  //         newErrors.clinicDetails = true;
  //     }
  //     if (formDataServiceType.serviceType === "other" && !formDataServiceType.otherDetails) {
  //         newErrors.otherDetails = true;
  //     }

  //     setErrors(newErrors);
  //     return Object.keys(newErrors).length === 0;
  // };

  // const validateFormServiceInfo = () => {
  //     let newErrors: { [key: string]: boolean } = {};
  //     if (!formData.organization_data.health_office_type) {
  //         newErrors.health_office_type = true;
  //     }

  //     setErrors(newErrors);
  //     return Object.keys(newErrors).length === 0;
  // };

  // const handleSubmit = () => {
  //     if (!validateFormServiceType() || !validateFormServiceInfo()) {
  //         Swal.fire({
  //             title: "กรุณากรอกข้อมูลให้ครบถ้วน",
  //             icon: "info",
  //         });
  //         return;
  //     }

  //     // แสดงข้อมูลที่ได้จากฟอร์ม
  //     // console.log("ข้อมูล ServiceType:", formDataServiceType);
  //     // console.log("ข้อมูล ServiceInfo:", formData);
  // };
  // console.log("formDataformDataformData", formData);

  const handleProvinceChange = (_: any, selectedOption: IProvince | null) => {
    if (selectedOption) {
      //    console.log("selectedOption", selectedOption.province_thai_name)
      setFormData((prev: any) => ({
        ...prev,
        organization_data: {
          ...prev.organization_data,
          province: selectedOption.province_thai_name,
          district: "",
          sub_district: "",
          zip_code: "",
        },
      }));
      setErrors((prev: any) => ({
        ...prev,
        organization_data: { ...prev.organization_data, province: false },
      }));
      getDataAllDistrict(selectedOption);
    }
  };

  const handleDistrictChange = (_: any, selectedOption: IDistrict | null) => {
    if (selectedOption) {
      setFormData((prev: any) => ({
        ...prev,
        organization_data: {
          ...prev.organization_data,
          district: selectedOption.district_thai_name,
          sub_district: "",
          zip_code: "",
        },
      }));
      setErrors((prev: any) => ({
        ...prev,
        organization_data: { ...prev.organization_data, district: false },
      }));
      getDataGetAllTambon(selectedOption);
    }
  };

  const handleTambonChange = (_: any, selectedOption: ITambon | null) => {
    if (selectedOption) {
      setFormData((prev: any) => ({
        ...prev,
        organization_data: {
          ...prev.organization_data,
          sub_district: selectedOption.tambon_thai_name,
          zip_code: selectedOption.zip_code,
        },
      }));
      setErrors((prev: any) => ({
        ...prev,
        organization_data: {
          ...prev.organization_data,
          sub_district: false,
          zip_code: false,
        },
      }));
    }
  };

  const handleBlur = () => {
    if (!formData.service_type_note) {
      // console.log("1");
      if (!formData.service_type_note) {
        setErrors((prevErrors: any) => ({
          ...prevErrors,
          service_type_note: false,
        }));
      } else {
        setErrors((prevErrors: any) => ({
          ...prevErrors,
          service_type_note: true,
        }));
      }
    } else {
      // console.log("2");
      setErrors((prevErrors: any) => ({
        ...prevErrors,
        service_type_note: false,
      }));
    }
  };

  // เคลียร์ error เมื่อฟิลด์ได้รับ focus
  const handleFocus = () => {
    setErrors((prevErrors: any) => ({
      ...prevErrors,
      service_type_note: false,
    }));
  };

  return (
    <form>
      <Grid container sx={{ mt: 3 }}>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 3, rowGap: 1 }}>
        {/* ข้อมูลหน่วยบริการ */}
        <Grid item xs={12} md={2} sx={{ alignSelf: "center" }}>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            ข้อมูลหน่วยบริการ
          </Typography>
        </Grid>
        <Grid item xs={12} md={10}>
          <Box
            sx={{
              backgroundColor: "#ffffff",
              border: "1px solid #ccc",
              borderRadius: "4px",
              p: 1,
            }}
          >
            {/* {formData.organization_data.health_office_type} */}
            <Grid container spacing={2}>
              {serviceOptions.map((option) => (
                <Grid item key={option.name}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={
                          formData.organization_data.health_office_type ===
                          option.name
                        }
                        onChange={() => handleCheckboxServiceInfo(option.name)}
                      />
                    }
                    label={option.label}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
          {errors.serviceType && (
            <Typography variant="body2" color="error">
              กรุณาเลือกประเภทหน่วยบริการอย่างใดอย่างหนึ่ง
            </Typography>
          )}
        </Grid>

        <Grid item xs={12} md={2}></Grid>
        <Grid item xs={12} md={10}>
          <Grid container spacing={2}>
            {/* ชื่อหน่วยบริการ */}
            <Grid item xs={12} md={6}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      ชื่อหน่วยบริการ <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกชื่อหน่วยบริการ"
                  value={formData.organization_data.hname_th}
                  name="hname_th"
                  //   onChange={handleFormChangeInfo}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const regex = /^[^\s]*$/; // regex ตรวจสอบว่าไม่มีช่องว่าง (space)

                    // ถ้าข้อความไม่รวมช่องว่าง (space) จะอัพเดตค่าใน form
                    if (regex.test(inputValue)) {
                      handleFormChangeInfo(
                        e as React.ChangeEvent<HTMLInputElement>
                      );
                    }
                  }}
                  error={errors.organization_data?.hname_th}
                  helperText={
                    errors.organization_data?.hname_th
                      ? "กรุณากรอกชื่อหน่วยบริการ"
                      : ""
                  }
                />
              </FormControl>
            </Grid>
            {/* รหัสหน่วยบริการ */}
            <Grid item xs={12} md={6}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      รหัสหน่วยบริการ <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกรหัสหน่วยบริการ"
                  value={formData.organization_data.hcode || ""}
                  name="hcode"
                  //   onChange={handleFormChangeInfo}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const regex = /^[^\s]*$/; // regex ตรวจสอบว่าไม่มีช่องว่าง (space)

                    // ถ้าข้อความไม่รวมช่องว่าง (space) จะอัพเดตค่าใน form
                    if (regex.test(inputValue)) {
                      handleFormChangeInfo(
                        e as React.ChangeEvent<HTMLInputElement>
                      );
                    }
                  }}
                  // error={errors.hcode}
                  // helperText={
                  //     errors.hcode ? "กรุณากรอกรหัสหน่วยบริการ" : ""
                  // }
                  error={errors.organization_data?.hcode}
                  helperText={
                    errors.organization_data?.hcode
                      ? "กรุณากรอกรหัสหน่วยบริการ"
                      : ""
                  }
                />
              </FormControl>
            </Grid>
            {/* สถานที่ตั้งหน่วยบริการ */}
            <Grid item xs={12} md={6}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      สถานที่ตั้งหน่วยบริการ{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกสถานที่ตั้งหน่วยบริการ"
                  value={formData.organization_data.address || ""}
                  name="address" // ✅ Fix name attribute
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const regex = /^[^\s]*$/; // regex ตรวจสอบว่าไม่มีช่องว่าง (space)

                    // ถ้าข้อความไม่รวมช่องว่าง (space) จะอัพเดตค่าใน form
                    if (regex.test(inputValue)) {
                      handleFormChangeInfo(
                        e as React.ChangeEvent<HTMLInputElement>
                      );
                    }
                  }}
                  error={!!errors.organization_data?.address} // Check for error in nested object
                  helperText={
                    errors.organization_data?.address
                      ? "กรุณากรอกสถานที่ตั้งหน่วยบริการ"
                      : ""
                  } // Custom error message
                />
              </FormControl>
            </Grid>
            {/* หมู่/อาคาร */}
            <Grid item xs={12} md={2}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      หมู่ / อาคาร <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกหมู่/อาคาร"
                  value={formData.organization_data.moo || ""}
                  name="moo"
                  onChange={(e) => {
                    const inputValue = e.target.value;

                    // ตรวจสอบว่าไม่ให้มีช่องว่างหลังคำแรก
                    const regex = /^[^\s]+(\s[^\s]*)?$/;

                    // อนุญาตให้ลบข้อความได้
                    if (inputValue === "" || regex.test(inputValue)) {
                      handleFormChangeInfo(e); // ถ้าข้อความตรงกับเงื่อนไข ก็อัพเดตค่า
                    }
                  }}
                  // error={errors.moo}
                  // helperText={errors.moo ? "กรุณากรอกหมู่ / อาคาร" : ""}
                  error={!!errors.organization_data?.moo} // Check for error in nested object
                  helperText={
                    errors.organization_data?.moo ? "กรุณากรอกหมู่ / อาครา" : ""
                  } // Custom error message
                />
              </FormControl>
            </Grid>
            {/* ตรอก/ซอย */}
            <Grid item xs={12} md={4}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ minWidth: "100%", backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      ตรอก / ซอย <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  id="outlined-basic"
                  placeholder="กรุณากรอกตรอก / ซอย"
                  value={formData.organization_data.soi || ""}
                  name="soi"
                  onChange={(e) => {
                    const inputValue = e.target.value;

                    // ตรวจสอบว่าไม่ให้มีช่องว่างหลังคำแรก
                    const regex = /^[^\s]+(\s[^\s]*)?$/;

                    // อนุญาตให้ลบข้อความได้
                    if (inputValue === "" || regex.test(inputValue)) {
                      handleFormChangeInfo(e); // ถ้าข้อความตรงกับเงื่อนไข ก็อัพเดตค่า
                    }
                  }}
                  // error={errors.soi}
                  // helperText={errors.soi ? "กรุณากรอกตรอก / ซอย" : ""}
                  error={!!errors.organization_data?.soi} // Check for error in nested object
                  helperText={
                    errors.organization_data?.soi ? "กรุณากรอกตรอก / ซอย" : ""
                  } // Custom error message
                />
              </FormControl>
            </Grid>
            {/* ถนน */}
            <Grid item xs={12}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ minWidth: "100%", backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      ถนน <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกถนน"
                  value={formData.organization_data.street || ""}
                  name="street"
                  onChange={(e) => {
                    const inputValue = e.target.value;

                    // ตรวจสอบว่าไม่ให้มีช่องว่างหลังคำแรก
                    const regex = /^[^\s]+(\s[^\s]*)?$/;

                    // อนุญาตให้ลบข้อความได้
                    if (inputValue === "" || regex.test(inputValue)) {
                      handleFormChangeInfo(e); // ถ้าข้อความตรงกับเงื่อนไข ก็อัพเดตค่า
                    }
                  }}
                  error={errors.organization_data?.street}
                  helperText={
                    errors.organization_data?.street ? "กรุณากรอกถนน" : ""
                  }
                />
              </FormControl>
            </Grid>
            {/* จังหวัด, อำเภอ, ตำบล / แขวง, รหัสไปรษณีย์ */}
            <Grid item xs={12} md={3}>
              <FormControl sx={{ minWidth: "100%" }}>
                {/* <Autocomplete
                                    options={provinceOptions}
                                    getOptionLabel={(option) => option.label}
                                    value={
                                        provinceOptions.find(
                                            (option) => option.value === formData.organization_data.province
                                        ) || null
                                    }
                                    onChange={(event, newValue) => {
                                        setFormData((prev: any) => ({
                                            ...prev,
                                            organization_data: {
                                                ...prev.organization_data,
                                                province: newValue?.value || "",
                                            },
                                        }));
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={
                                                <span>
                                                    จังหวัด <span style={{ color: "red" }}>*</span>
                                                </span>
                                            }
                                            placeholder="กรุณาเลือกจังหวัด"
                                            error={errors.province}
                                            helperText={errors.province ? "กรุณาเลือกจังหวัด" : ""}
                                        />
                                    )}
                                /> */}
                <Autocomplete
                  id="province-select"
                  clearIcon={false}
                  options={allProvince}
                  value={
                    allProvince.find(
                      (option) =>
                        option.province_thai_name ===
                        formData.organization_data.province
                    ) || null
                  }
                  getOptionLabel={(option) => option.province_thai_name || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.province_code === value.province_code
                  }
                  onChange={(_, value) => {
                    if (value) {
                      handleProvinceChange("", value);
                      // handleFormChange({
                      //   target: {
                      //     name: "province",
                      //     value: value.province_thai_name,
                      //   },
                      // } as React.ChangeEvent<HTMLInputElement>);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          จังหวัด <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="province"
                      variant="outlined"
                      fullWidth
                      error={!!errors.organization_data?.province} // Check for error in nested object
                      helperText={
                        errors.organization_data?.province
                          ? "กรุณาเลือกจังหวัด"
                          : ""
                      } // Custom error message
                      // error={!!errors["organization_data.province"]}
                      // helperText={errors["organization_data.province"] ? "กรุณาเลือกจังหวัด" : ""}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "4px",
                          backgroundColor: "#ffffff",
                        },
                      }}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl sx={{ minWidth: "100%" }}>
                {/* <Autocomplete
                                    options={districtOptions}
                                    getOptionLabel={(option) => option.label}
                                    value={
                                        districtOptions.find(
                                            (option) => option.value === formData.organization_data.district
                                        ) || null
                                    }
                                    onChange={(event, newValue) => {

                                        setFormData((prev: any) => ({
                                            ...prev,
                                            organization_data: {
                                                ...prev.organization_data,
                                                district: newValue?.value || "",
                                            },
                                        }));
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={
                                                <span>
                                                    อำเภอ <span style={{ color: "red" }}>*</span>
                                                </span>
                                            }
                                            placeholder="กรุณาเลือกอำเภอ"
                                            error={errors.district}
                                            helperText={errors.district ? "กรุณาเลือกอำเภอ" : ""}
                                        />
                                    )}
                                /> */}
                <Autocomplete
                  clearIcon={false}
                  id="district-select"
                  disabled={
                    !formData.organization_data.province || loadingDistricts
                  }
                  options={allDistricts}
                  getOptionLabel={(option) => option.district_thai_name}
                  value={
                    allDistricts.find(
                      (option) =>
                        option.district_thai_name ===
                        formData.organization_data.district
                    ) || null
                  }
                  onChange={(_, value) => {
                    if (value) {
                      handleDistrictChange("", value);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          อำเภอ <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="district"
                      variant="outlined"
                      fullWidth
                      error={!!errors.organization_data?.district}
                      helperText={
                        errors.organization_data?.district
                          ? "กรุณาเลือกอำเภอ"
                          : ""
                      } // Custom error message
                      // error={!!errors["organization_data.district"]}
                      // helperText={errors["organization_data.district"] ? "กรุณาเลือกอำเภอ" : ""}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "4px",
                          backgroundColor: "#ffffff",
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loadingDistricts ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl sx={{ minWidth: "100%" }}>
                {/* <Autocomplete
                                    options={sub_districtOptions}
                                    getOptionLabel={(option) => option.label}
                                    value={
                                        sub_districtOptions.find(
                                            (option) => option.value === formData.organization_data.sub_district
                                        ) || null
                                    }
                                    onChange={(event, newValue) => {
                                        setFormData((prev: any) => ({
                                            ...prev,
                                            organization_data: {
                                                ...prev.organization_data,
                                                sub_district: newValue?.value || "",
                                            },
                                        }));
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={
                                                <span>
                                                    ตำบล / แขวง <span style={{ color: "red" }}>*</span>
                                                </span>
                                            }
                                            placeholder="กรุณาเลือกตำบล / แขวง"
                                            error={errors.sub_district}
                                            helperText={
                                                errors.sub_district ? "กรุณาเลือกตำบล / แขวง" : ""
                                            }
                                        />
                                    )}
                                /> */}
                <Autocomplete
                  clearIcon={false}
                  id="subdistrict-select"
                  disabled={
                    !formData.organization_data.district || loadingTambon
                  }
                  options={allTambon ?? []} // ป้องกัน options เป็น null หรือ undefined
                  value={
                    allTambon && Array.isArray(allTambon)
                      ? allTambon.find(
                          (option) =>
                            option.tambon_thai_name ===
                            formData.organization_data.sub_district
                        ) || null
                      : null
                  }
                  getOptionLabel={(option) => option.tambon_thai_name}
                  onChange={(_, value) => {
                    if (value) {
                      handleTambonChange("", value);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          ตำบล / แขวง <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="sub_district"
                      variant="outlined"
                      fullWidth
                      error={!!errors.organization_data?.sub_district} // Check for error in nested object
                      helperText={
                        errors.organization_data?.sub_district
                          ? "กรุณาเลือกตำบล / แขวง"
                          : ""
                      } // Custom error message
                      // error={!!errors["organization_data.street"]}
                      // helperText={errors["organization_data.street"] ? "กรุณาเลือกตำบล / แขวง" : ""}
                      sx={{
                        backgroundColor: "#ffffff",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "4px",
                          backgroundColor: "#ffffff",
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loadingTambon ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  disabled={
                    loadingTambon || !formData?.organization_data?.sub_district
                  }
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      รหัสไปรษณีย์ <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกรหัสไปรษณีย์"
                  value={formData.organization_data.zip_code || ""}
                  name="zip_code"
                  // onChange={handleFormChangeInfo}
                  onInput={(e) => {
                    const input = e.target as HTMLInputElement;
                    input.value = input.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 5);
                  }}
                  inputProps={{
                    maxLength: 5,
                    pattern: "[0-9]*",
                    inputMode: "numeric",
                  }}
                  error={
                    !!errors.organization_data?.zip_code ||
                    (formData.organization_data.zip_code.length > 0 &&
                      formData.organization_data.zip_code.length < 5)
                  }
                  helperText={
                    errors.organization_data?.zip_code ||
                    (formData.organization_data.zip_code.length > 0 &&
                    formData.organization_data.zip_code.length < 5
                      ? "กรุณากรอกรหัสไปรษณีย์ให้ครบ 5 หลัก"
                      : "")
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      ไปรษณีย์อิเล็กทรอนิกส์{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกไปรษณีย์อิเล็กทรอนิกส์"
                  value={formData.organization_data.email || ""}
                  name="email"
                  // onChange={handleFormChangeInfo}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const regex = /^[^\s]*$/; // regex ตรวจสอบว่าไม่มีช่องว่าง (space)

                    // ถ้าข้อความไม่รวมช่องว่าง (space) จะอัพเดตค่าใน form
                    if (regex.test(inputValue)) {
                      handleFormChangeInfo(
                        e as React.ChangeEvent<HTMLInputElement>
                      );
                    }
                  }}
                  error={errors.organization_data?.email}
                  helperText={
                    errors.organization_data?.email
                      ? "กรุณากรอกไปรษณีย์อิเล็กทรอนิกส์"
                      : ""
                  }
                  // error={!!errors["organization_data.email"]}
                  // helperText={errors["organization_data.email"] ? "กรุณากรอกไปรษณีย์อิเล็กทรอนิกส์" : ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl sx={{ minWidth: "100%" }}>
                <TextField
                  variant="outlined"
                  sx={{ backgroundColor: "#ffffff" }}
                  label={
                    <span>
                      หมายเลขโทรศัพท์มือถือ{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  placeholder="กรุณากรอกหมายเลขโทรศัพท์มือถือ"
                  value={formData.organization_data.mobile_number || ""}
                  name="mobile_number"
                  onChange={handleFormChangeInfo}
                  error={errors.organization_data?.mobile_number}
                  helperText={
                    errors.organization_data?.mobile_number
                      ? "กรุณากรอกหมายเลขโทรศัพท์มือถือ"
                      : ""
                  }
                  // error={!!errors["organization_data.mobile_number"]}
                  // helperText={errors["organization_data.mobile_number"] ? "กรุณากรอกหมายเลขโทรศัพท์มือถือ" : ""}

                  inputProps={{
                    maxLength: 10,
                    pattern: "[0-9]*",
                    inputMode: "numeric",
                  }}
                />
              </FormControl>
            </Grid>

            <Grid container sx={{ mt: 3 }}>
              <Grid item xs={12}>
                <Divider />
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ mt: 3, rowGap: 1 }}>
              <Grid item xs={12} md={2} sx={{ alignSelf: "flex-start", mt: 1 }}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  ประเภทบริการ
                </Typography>
              </Grid>
              <Grid item xs={12} md={10}>
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  sx={{
                    backgroundColor: "#ffffff",
                    borderRadius: "4px",
                    p: 1,
                    border: "1px solid #ccc",
                  }}
                >
                  {/* คลินิกเวชกรรม */}
                  <Grid item xs={12} sm={6} sx={{ pl: 1 }}>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ display: { xs: "block", sm: "flex" } }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.service_type === "คลินิกเวชกรรม"}
                            onChange={() =>
                              handleCheckboxServiceType("คลินิกเวชกรรม")
                            }
                          />
                        }
                        label="คลินิกเวชกรรม"
                      />
                    </Grid>
                  </Grid>

                  {/* คลินิกกายภาพบำบัด */}
                  <Grid item xs={12} sm={6} sx={{ pl: 1 }}>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ display: { xs: "block", sm: "flex" } }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              formData.service_type === "คลินิกกายภาพบำบัด"
                            }
                            onChange={() =>
                              handleCheckboxServiceType("คลินิกกายภาพบำบัด")
                            }
                          />
                        }
                        label="คลินิกกายภาพบำบัด"
                      />
                    </Grid>
                  </Grid>

                  {/* คลินิกทันตกรรม */}
                  <Grid item xs={12} sm={6} sx={{ pl: 1 }}>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ display: { xs: "block", sm: "flex" } }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.service_type === "คลินิกทันตกรรม"}
                            onChange={() =>
                              handleCheckboxServiceType("คลินิกทันตกรรม")
                            }
                          />
                        }
                        label="คลินิกทันตกรรม"
                      />
                    </Grid>
                  </Grid>

                  {/* คลินิกการแพทย์แผนไทย */}
                  <Grid item xs={12} sm={6} sx={{ pl: 1 }}>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ display: { xs: "block", sm: "flex" } }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              formData.service_type === "คลินิกการแพทย์แผนไทย"
                            }
                            onChange={() =>
                              handleCheckboxServiceType("คลินิกการแพทย์แผนไทย")
                            }
                          />
                        }
                        label="คลินิกการแพทย์แผนไทย"
                      />
                    </Grid>
                  </Grid>

                  {/* คลินิกเฉพาะด้าน */}
                  <Grid item xs={12} sm={6} sx={{ pl: 1 }}>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ display: { xs: "block", sm: "flex" } }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              formData.service_type === "คลินิกเฉพาะด้าน"
                            }
                            onChange={() =>
                              handleCheckboxServiceType("คลินิกเฉพาะด้าน")
                            }
                          />
                        }
                        label="คลินิกเฉพาะด้าน"
                      />
                    </Grid>
                  </Grid>

                  {/* คลินิกการประกอบโรคศิลปะ */}
                  <Grid item xs={12} sm={6} sx={{ pl: 1 }}>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ display: { xs: "block", sm: "flex" } }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              formData.service_type ===
                              "คลินิกการประกอบโรคศิลปะ"
                            }
                            onChange={() =>
                              handleCheckboxServiceType(
                                "คลินิกการประกอบโรคศิลปะ"
                              )
                            }
                          />
                        }
                        label="คลินิกการประกอบโรคศิลปะ"
                      />
                    </Grid>
                  </Grid>

                  {/* คลินิกเทคนิคการแพทย์ */}
                  <Grid item xs={12} sm={6} sx={{ pl: 1 }}>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ display: { xs: "block", sm: "flex" } }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              formData.service_type === "คลินิกเทคนิคการแพทย์"
                            }
                            onChange={() =>
                              handleCheckboxServiceType("คลินิกเทคนิคการแพทย์")
                            }
                          />
                        }
                        label="คลินิกเทคนิคการแพทย์"
                      />
                    </Grid>
                  </Grid>

                  {/* สหคลินิก ประกอบด้วย */}
                  <Grid item xs={12} sm={6} sx={{ pl: 1 }}>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ display: { xs: "block", sm: "flex" } }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.service_type === "สหคลินิก"}
                            onChange={() =>
                              handleCheckboxServiceType("สหคลินิก")
                            }
                          />
                        }
                        label="สหคลินิก ประกอบด้วย"
                      />
                      <TextField
                        variant="standard"
                        sx={{ flex: 1 }}
                        label={
                          <span>
                            โปรดระบุ <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        name="service_type_note"
                        onChange={handleTextServiceType}
                        // value={formData.service_type_note || ''}
                        value={
                          formData.service_type === "สหคลินิก"
                            ? formData.service_type_note
                            : ""
                        }
                        disabled={formData.service_type !== "สหคลินิก"}
                        error={
                          formData.service_type === "สหคลินิก" &&
                          errors.service_type_note
                        }
                        helperText={
                          formData.service_type === "สหคลินิก" &&
                          errors.service_type_note
                            ? "โปรดระบุ"
                            : ""
                        }
                        // error={errors.service_type_note}
                        // helperText={errors.service_type_note ? "โปรดระบุ" : ""}
                        // onBlur={handleBlur}  // ตรวจสอบเมื่อผู้ใช้คลิกออกจากฟิลด์
                        // onFocus={handleFocus} // รีเซ็ต error เมื่อฟิลด์ได้รับ focus
                      />
                    </Grid>
                  </Grid>

                  {/* คลินิกการพยาบาลและการผดุงครรภ์ */}
                  <Grid item xs={12} sm={6} sx={{ pl: 1 }}>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ display: { xs: "block", sm: "flex" } }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              formData.service_type ===
                              "คลินิกการพยาบาลและการผดุงครรภ์"
                            }
                            onChange={() =>
                              handleCheckboxServiceType(
                                "คลินิกการพยาบาลและการผดุงครรภ์"
                              )
                            }
                          />
                        }
                        label="คลินิกการพยาบาลและการผดุงครรภ์"
                      />
                    </Grid>
                  </Grid>

                  {/* ร้านยา */}
                  <Grid item xs={12} sm={6} sx={{ pl: 1 }}>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ display: { xs: "block", sm: "flex" } }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.service_type === "ร้านยา"}
                            onChange={() => handleCheckboxServiceType("ร้านยา")}
                          />
                        }
                        label="ร้านยา"
                      />
                    </Grid>
                  </Grid>

                  {/* โรงพยาบาล */}
                  <Grid item xs={12} sm={6} sx={{ pl: 1 }}>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ display: { xs: "block", sm: "flex" } }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.service_type === "โรงพยาบาล"}
                            onChange={() =>
                              handleCheckboxServiceType("โรงพยาบาล")
                            }
                          />
                        }
                        label="โรงพยาบาล"
                      />
                    </Grid>
                  </Grid>

                  {/* อื่นๆ */}
                  <Grid item xs={12} sm={6} sx={{ pl: 1 }}>
                    <Grid
                      container
                      alignItems="center"
                      sx={{ display: { xs: "block", sm: "flex" } }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={formData.service_type === "อื่นๆ"}
                            onChange={() => handleCheckboxServiceType("อื่นๆ")}
                          />
                        }
                        label="อื่นๆ"
                      />
                      <TextField
                        variant="standard"
                        sx={{ flex: 1 }}
                        label={
                          <span>
                            โปรดระบุ <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        onChange={handleTextServiceType}
                        name="service_type_note"
                        value={
                          formData.service_type === "อื่นๆ"
                            ? formData.service_type_note
                            : ""
                        }
                        // error={errors.service_type_note}
                        // helperText={errors.service_type_note ? "โปรดระบุ" : ""}
                        error={
                          formData.service_type === "อื่นๆ" &&
                          errors.service_type_note
                        }
                        helperText={
                          formData.service_type === "อื่นๆ" &&
                          errors.service_type_note
                            ? "โปรดระบุ"
                            : ""
                        }
                        disabled={formData.service_type !== "อื่นๆ"}
                        // onBlur={handleBlur}  // ตรวจสอบเมื่อผู้ใช้คลิกออกจากฟิลด์
                        // onFocus={handleFocus} // รีเซ็ต error เมื่อฟิลด์ได้รับ focus
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* <Grid container spacing={1} alignItems="center">(ติดตรงนี้อยู่ค่ายังไม่ตาม)
                                    {clinicOptions.map((option) => (
                                        <Grid key={option.value} item xs={12} sm={6} sx={{ pl: 1 }}>
                                            <Grid container alignItems="center" sx={{ display: { xs: "block", sm: "flex" } }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={formData.service_type === option.value}
                                                            onChange={() => handleCheckboxServiceType(option.value)}
                                                        />
                                                    }
                                                    label={option.label}
                                                />

                                                {(option.value === "multiClinic" || option.value === "other") && (
                                                    <Grid item xs={12} sm="auto">
                                                        <TextField
                                                            name={option.value === "multiClinic" ? "clinicDetails" : "otherDetails"}
                                                            variant="standard"
                                                            sx={{ flex: 1 }}
                                                            label={<span>โปรดระบุ <span style={{ color: "red" }}>*</span></span>}
                                                            onChange={handleTextServiceType}
                                                            value={option.value === "multiClinic" ? formData.service_type_note : formDataServiceType.otherDetails}
                                                            error={!!errors[option.value === "multiClinic" ? "clinicDetails" : "otherDetails"]}
                                                            helperText={
                                                                errors[option.value === "multiClinic" ? "clinicDetails" : "otherDetails"]
                                                                    ? "กรุณากรอกรายละเอียด"
                                                                    : ""
                                                            }
                                                            disabled={formData.service_type !== option.value}
                                                        />
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Grid>
                                    ))}
                                </Grid> */}

                <Grid container sx={{ mt: 7 }}>
                  <Grid item xs={12}>
                    <Typography variant="body1">
                      *หมายเหตุ : หน่วยบริการฯ สามารถสมัครเข้าร่วมตามนโยบาย “๓๐
                      บาทรักษาทุกที่ ด้วยบัตรประชาชนใบเดียว”
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1">
                      ผ่านการสมัครโดยตรงกับสำนักงานสาธารณสุขจังหวัด เท่านั้น
                      เนื่องจากต้องมีการตรวจสอบเอกสารประกอบการสมัคร
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* <ServiceType formDataServiceType={formDataServiceType} handleCheckboxServiceType={handleCheckboxServiceType} handleTextServiceType={handleTextServiceType} errors={errors} /> */}
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default ServiceInfoV1;
